/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Calendar_MicrosoftInputs */



/**
* | output |
* | --- |
* | "Microsoft 365" |
*
* @param {Onboarding_Calendar_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_calendar_microsoft = /** @type {((inputs?: Onboarding_Calendar_MicrosoftInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Calendar_MicrosoftInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Microsoft 365")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Microsoft 365")
	return /** @type {LocalizedString} */ ("Microsoft 365")
});